module.exports = __webpack_public_path__ + "img/swiper2.ae7376a9.png";